export const getPathArray = (path: string) => {
  if (typeof path !== "string") return [];
  return path.split("/").filter((item) => !!item);
}
